import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as repoBusinessActions from './repo-business.action';
import * as repoBusinessSelectors from './repo-business.selector';
import { Position, RepoBusiness, RepoContact } from '../../../models/repo-business/repo-business.model';

@Injectable({
  providedIn: 'root',
})
export class RepoBusinessFacade {
  
  repoBusinesses$: Observable<RepoBusiness[]> = this.store.pipe(select(repoBusinessSelectors.selectRepoBusinesses));
  positions$: Observable<Position[]> = this.store.pipe(select(repoBusinessSelectors.selectPositions));
  allContacts$: Observable<RepoContact[]> = this.store.pipe(select(repoBusinessSelectors.selectAllContacts));
  loading$: Observable<boolean> = this.store.pipe(select(repoBusinessSelectors.selectRepoBusinessLoading));
  success$: Observable<any | null> = this.store.pipe(select(repoBusinessSelectors.selectRepoBusinessSuccess));
  error$: Observable<any> = this.store.pipe(select(repoBusinessSelectors.selectRepoBusinessError));

  constructor(private store: Store) {
    
  }

  contactsByBusinessId$(businessId: number): Observable<RepoContact[]> {
    return this.store.pipe(
      select(repoBusinessSelectors.selectContactsByBusinessId(businessId))
    );
  }

  loadRepoBusinesses() {
    this.store.dispatch(repoBusinessActions.loadRepoBusinesses());
  }

  loadPositions() {
    this.store.dispatch(repoBusinessActions.loadPositions());
  }

  deletePosition(positionId: number) {
    this.store.dispatch(repoBusinessActions.deletePosition({positionId}));
  }

  deleteBusiness(repoBusinessId: number) {
    this.store.dispatch(repoBusinessActions.deleteBusiness({ repoBusinessId }));
  }

  loadContactsByRepoBusinessId(repoBusinessId: number) {
    this.store.dispatch(repoBusinessActions.loadContactsByRepoBusinessId({ repoBusinessId }));
  }

  loadContacts() {
    this.store.dispatch(repoBusinessActions.loadContactsByRepoBusinessId({ repoBusinessId:0 }));
  }

  saveRepoBusiness(repoBusiness: RepoBusiness) {
    this.store.dispatch(repoBusinessActions.saveRepoBusiness({ repoBusiness }));
  }

  savePosition(position: Position) {
    this.store.dispatch(repoBusinessActions.savePosition({ position }));
  }

  saveRepoContact(repoContact: RepoContact) {
    this.store.dispatch(repoBusinessActions.saveRepoContact({ repoContact }));
  }
}
